import React from "react";

export const ScriptsComponent = () => {
  return (
    <>  
      
      {/* <!-- Bootstrap JS --> */}
      <script src="/horizontal/assets/js/bootstrap.bundle.min.js"></script>
      {/* <!--plugins--> */}
      <script src="/horizontal/assets/js/jquery.min.js"></script>
      <script src="/horizontal/assets/plugins/simplebar/js/simplebar.min.js"></script>
      <script src="/horizontal/assets/plugins/metismenu/js/metisMenu.min.js"></script>
      <script src="/horizontal/assets/plugins/perfect-scrollbar/js/perfect-scrollbar.js"></script>
      <script src="/horizontal/assets/plugins/vectormap/jquery-jvectormap-2.0.2.min.js"></script>
      <script src="/horizontal/assets/plugins/vectormap/jquery-jvectormap-world-mill-en.js"></script>
      <script src="/horizontal/assets/plugins/chartjs/js/chart.js"></script>
      <script src="/horizontal/assets/js/index.js"></script>
      {/* <!--app JS--> */}
      <script src="/horizontal/assets/js/app.js"></script>
      {/* <script>
            new PerfectScrollbar(".app-container")
        </script> */}

      <script src="/horizontal/assets/plugins/bs-stepper/js/bs-stepper.min.js"></script>
      <script src="/horizontal/assets/plugins/bs-stepper/js/main.js"></script>
      {/* <script src="https://cdn.tiny.cloud/1/gd6wms1x45iapsb4j9wyd0r799gkk6vpsp3ct2l93h49b15y/tinymce/5/tinymce.min.js"></script> */}
    </>
  );
};
